import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { FormService, ErrorTranslationService } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';

import { camps } from '../../../../../../../../../models/models.generated';
import { DayVariantManagementApiService } from '../../../../../../../../../services/api/day-variant-management-api.service';
import { CampsDetailsFormStateService } from '../../../../../../camp-details-form-state-service';

@Component({
    selector: 'app-day-variant-details-edit',
    templateUrl: './day-variant-details-edit.component.html',
    styleUrls: ['./day-variant-details-edit.component.scss'],
    standalone: false
})
export class DayVariantDetailsEditComponent implements OnInit {
    @Input() public form: UntypedFormGroup;

    @Output() canceled: EventEmitter<UntypedFormGroup> = new EventEmitter();

    constructor(
        private state: CampsDetailsFormStateService,
        private api: DayVariantManagementApiService,
        private alert: BayclubsAlertService,
        private errorTranslate: ErrorTranslationService
    ) {}

    ngOnInit(): void {}

    public save() {
        var request = <camps.SessionDayVariantSaveRequest>{
            dayVariantId: this.form.get('id').value,
            sessionId: this.form.get('sessionId').value,
            name: this.form.get('name').value,
            order: this.form.get('order').value,
            dates: this.form.get('daysDates').value,
            isVisibleToMembers: this.form.get('isVisibleToMembers').value
        };

        this.api.save(request).subscribe(x => {
            if (x.isSuccess) {
                this.alert.showOperationSuccess();
                this.form.get('id').setValue(x.value.id);
                this.state.sessionChanged.emit(request.sessionId);
                this.state.finishEdit(this.form);
            } else {
                this.errorTranslate.translateValidationNotifications(x.validationNotification);
                this.alert.showError(x.validationNotification.errors[0].message);
            }
        });
    }

    public cancel() {
        this.canceled.emit(this.form);
    }

    public isFormValid() {
        return FormService.isFormValid(this.form);
    }

    public onVisibleChange($event) {
        this.form.controls.isVisibleToMembers.setValue($event);
        FormService.updateValueAndValidity(this.form);
    }
}
